import React, { useContext, useState } from 'react'
import { AiFillEye, AiFillFileImage, AiOutlineHistory, AiOutlineInfoCircle } from 'react-icons/ai'
import { Avatar, Checkbox, IconButton, TableBody, TableCell, TableRow, Typography } from '@material-ui/core'
import { Grid } from '@material-ui/core'
import Layout from '../Layout'
import CustomTable from '../Table/CustomTable'
import CustomTableHeading from '../Table/CustomTableHeading'
import Loader from '../Loader'
import CustomPagination from '../CustomPagination'
import CustomDatePicker from '../CustomDatePicker'
import CustomSelect from '../CustomSelect'
import { NoDataFound } from '../NoDataFound'
import CustomSwitch from '../CustomSwitch'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import { useHistory } from 'react-router-dom'
import ImageDialog from '../Dialog/ImageDialog'
import Status from '../Status'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
import CustomDialog from '../CustomDialog'
import HeadingWithCloseIcon from '../HeadingWithCloseIcon'
import CustomFilterModal from '../FilterArray/FilterArray'
import { UserContext } from '../../context api/UserContext'
import CustomHeading from '../CustomHeading'
import CustomButton from '../CustomButton'
import CustomInput from '../CustomInput'
import ActionIcons from '../ActionIcons'
import { paginatedData } from '../../shared/constants'

export default function CustomTableLayout({
  tableHeadings = [],
  tableBody = [],
  filterIcons = {},
  loading = false,
  handleSwitchChange = () => {},
  paginate = {},
  handlePageChange = () => {},
  layoutProps = {},
  checkbox,
  deleteMany = () => {},
  filterParams,
  setFilterParams = () => {},
  modalData = {},
  modalOpen = false,
  setModalOpen = () => {},
  paginateFront = false,
  border = false,
  to = '',
  from = '',
  setTo = {},
  setFrom = {},
  channelInput = [],
}) {
  // //console.log('MODAL DATA : ', modalData)
  const [selected, setSelected] = React.useState({})
  const history = useHistory()
  const [imageDialog, setImageDialog] = useState(false)
  const [location, setLocation] = useState(false)
  const [openFilterModal, setOpenFilterModal] = React.useState(false)
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const user = useContext(UserContext)
  const userType = user.user.userType === 'SUPERADMIN' || (user && user.user.userType === 'COMPANYADMIN')
  let mainPermission = []
  let permissions = []
  let userFeatures = user.user && user.user.allowedFeatures

  // added after subscription integration
  //  debugger;sss
  // if(user.user.userType === "COMPANYADMIN"){
  //   userFeatures = user.user.companyPermissions
  //   console.log("COMPANY PERMISSIONS", userFeatures)
  // }
  userFeatures &&
    userFeatures.forEach((val) => {
      mainPermission.push(val.module)
      if (val.module === layoutProps.permissionName || layoutProps.permissionName?.toUpperCase()) {
        permissions.push(...val.subPermission)
      }
    })

  const checkEditAdndDeletePermission = userType || permissions.includes('UPDATE') || permissions.includes('DELETE')
  console.log({ checkEditAdndDeletePermission })
  const handleSelectChange = (id) => {
    let tempObj = { ...selected }
    if (tempObj[id]) delete tempObj[id]
    else tempObj[id] = true
    setSelected(tempObj)
  }
  // convertArrayToObject()
  const handleSelectAllChange = () => {
    if (Object.keys(selected).length === tableBody.length) setSelected({})
    else {
      let tempObj = {}
      tableBody.forEach((item) => (tempObj[item[0]._id] = true))
      setSelected(tempObj)
    }
  }

  if (checkbox)
    tableHeadings = [
      checkEditAdndDeletePermission && (
        <Checkbox
          indeterminate={Object.keys(selected).length > 0 && Object.keys(selected).length < tableBody.length}
          checked={tableBody.length > 0 && Object.keys(selected).length === tableBody.length}
          onClick={handleSelectAllChange}
        />
      ),
      ...tableHeadings,
    ]
  const paginateData = tableBody
  console.log({ paginateData })
  console.log({ layoutProps })

  let obj = {
    ...layoutProps,
    filename: loading ? false : layoutProps.filename,
  }
  return (
    <Layout {...obj} selectedData={Object.keys(selected)} setMultipleDeleteDialog={setMultipleDeleteDialog} editUrl={layoutProps.editUrl + Object.keys(selected)[0]} paginateFront={paginateFront}>
      {/* {to!= '' && from != '' && <div style={{ display: 'flex', marginBottom: '20px', flexDirection: 'row-reverse' }}>
        {to!== '' && <CustomDatePicker selectedDate={to} setSelectedDate={setTo} defaultValue="To" height="37px" />}
        {from!== '' && <CustomDatePicker selectedDate={from} setSelectedDate={setFrom} defaultValue="From" height="37px" />}
      </div> }  */}

      {
        <div style={{ background: 'light gray', width: '90%', marginLeft: '25px', maraginBottom: '15px', borderRadius: '10px', alignItems: 'center' }}>
          <Grid container spacing={1}>
            {from !== '' && (
              <Grid item lg={4}>
                <CustomDatePicker selectedDate={from} setSelectedDate={setFrom} defaultValue="From" height="37px" />
              </Grid>
            )}
            {to !== '' && (
              <Grid item lg={4}>
                <CustomDatePicker selectedDate={to} setSelectedDate={setTo} defaultValue="To" height="37px" />
              </Grid>
            )}
            {channelInput.length > 0 &&
              channelInput.map((item) => {
                return (
                  <Grid item lg={4}>
                    <CustomSelect
                      label={item.label}
                      name={item.name}
                      value={item.value}
                      fieldValue={item.fieldValue}
                      fieldName={item.fieldName}
                      options={item.options}
                      handleChange={item.handleChange}
                    />
                  </Grid>
                )
              })}
          </Grid>
        </div>
      }

      {filterParams && (
        <CustomFilterModal
          open={modalOpen || openFilterModal}
          setOpen={setModalOpen || setOpenFilterModal}
          data={modalData['data']}
          fieldValue={modalData.fieldValue}
          fieldName={modalData.fieldName}
          handleFilter={(filterData) => setFilterParams({ ...filterParams, [modalOpen]: filterData })}
          filterParams={filterParams[modalOpen]}
        />
      )}

      {layoutProps['GridAttend'] ? (
        layoutProps['dashboardLayout']
      ) : (
        <>
          {layoutProps.allow || userType || mainPermission.includes(layoutProps.permissionName && layoutProps.permissionName.toUpperCase()) ? (
            <CustomTable border={border}>
              <CustomTableHeading heading={tableHeadings} filterIcons={filterIcons} setFilterParams={setFilterParams} filterParams={filterParams} />
              <TableBody>
                {!loading &&
                  paginateData.map(
                    (
                      val // val be array of objects
                    ) => {
                      return (
                        <TableRow>
                          {val?.map((item, index) => {
                            let isSelected = selected[item._id] ? true : false
                            return (
                              <TableCell key={index} onClick={item.onClick} style={item.style} className={item.className}>
                                {item.type === 'CHECKBOX' && checkEditAdndDeletePermission && <Checkbox checked={isSelected} onClick={() => handleSelectChange(item._id)} />}
                                {item.type === 'INFO' && <AiOutlineInfoCircle style={{ width: '20px', height: '20px', cursor: 'pointer' }} />}
                                {item.type === 'STATUS' && <CustomSwitch checked={item.active} handleChange={() => handleSwitchChange(item)} />}
                                {item.type === 'STATUS_ENUM' && <Status status={item.lateFlag ? 'LATE' : item.status} />}
                                {item.type === 'LOCATION' && (
                                  <div onClick={() => setLocation(item.currentLocation || item.location)} style={{ cursor: 'pointer' }}>
                                    <LocationOnOutlinedIcon style={{ color: '#32499F' }} /> {item.location}
                                  </div>
                                )}
                                {item.type === 'BUTTON' && <CustomButton text={item.text} disabled={item.disabled} handleSubmit={item.onClick} />}
                                {item.type === 'IMAGE' && (
                                  // <LazyLoad>
                                  <Avatar
                                    src={item.image}
                                    onClick={() => {
                                      console.log(item.image)
                                      setImageDialog(item.image)
                                    }}
                                    profile={item.profile == undefined ? true : item.profile}
                                    style={{ cursor: 'pointer' }}
                                  />
                                  // </LazyLoad>
                                )}
                                {item.type === 'HISTORY' && (
                                  <IconButton color="inherit" onClick={() => history.push(`/single-employee/${item.employeeId}`)}>
                                    <AiOutlineHistory />
                                  </IconButton>
                                )}
                                {!item.type && Array.isArray(item.value) ? (
                                  <>
                                    {item.value.map((array) => (
                                      <>
                                        {array}
                                        <br />
                                        <br />
                                      </>
                                    ))}
                                  </>
                                ) : (
                                  item.value
                                )}

                                {item.type === 'ACTION' && item.status !== 'OPEN' && <ActionIcons approve={item.approveDialog} reject={item.declineDialog} display={item.display} />}
                                {item.type === 'VIEW' && (
                                  <IconButton onClick={item.onClick}>
                                    <AiFillEye />
                                  </IconButton>
                                )}
                                {item.type === 'VIEW_IMAGE' && (
                                  <IconButton>
                                    <AiFillFileImage />
                                  </IconButton>
                                )}
                              </TableCell>
                            )
                          })}
                        </TableRow>
                      )
                    }
                  )}
              </TableBody>
            </CustomTable>
          ) : (
            <div style={{ textAlign: 'center', marginTop: '10%' }}>
              <CustomHeading heading="You Don't Have Access to This Module" />
            </div>
          )}
          {loading && <Loader />}

          {!loading && tableBody.length === 0 && <NoDataFound />}

          {(layoutProps.allow || userType || mainPermission.includes(layoutProps.permissionName)) && !loading && tableBody.length > 0 && (
            <CustomPagination noOfPages={paginate.totalPage} page={paginate.page} handleChange={handlePageChange} />
          )}

          {imageDialog && <ImageDialog image={imageDialog} open={imageDialog} handleClose={() => setImageDialog(false)} />}
          {location && (
            <CustomDialog open={location && true} handleClose={() => setLocation(false)}>
              <HeadingWithCloseIcon heading="Full Address" handleClose={() => setLocation(false)} />
              <Typography> {location} </Typography>
            </CustomDialog>
          )}

          <ConfirmDialog open={multipleDeleteDialog} handleClose={() => setMultipleDeleteDialog(false)} handleSubmit={() => deleteMany(Object.keys(selected), setSelected)} />
        </>
      )}
    </Layout>
  )
}
